import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconSocialTiktokSvg } from "./IconSocialTiktokSvg.mjs";
const IconSocialTiktok = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconSocialTiktokSvg, ...svgProps }) });
export {
  IconSocialTiktok
};
